import axios from 'axios'
import Cookies from 'js-cookie'
import System from "src/helper/system";
import RoleAndPermission from "src/helper/RoleAndPermission";
import Helper from 'src/support/Helper';

const auth_axios = axios.create({})

// if (Cookies.get('LtpaToken2')) {
//     auth_axios.defaults.headers.common['ltpaToken'] = Cookies.get('LtpaToken2')
// } else {
//     window.avUserInfo = {};
//     auth_axios.defaults.headers.common['avUserInfo'] = System.getCurrentAvuserInfoCookie();
//     RoleAndPermission.loadPermissionBasedOnAuthRole()
// }

// if (Cookies.get(window.avUserInfo_cookie_name)) {
//     window.avUserInfo = JSON.parse(Cookies.get(window.avUserInfo_cookie_name));
//     let d = new Date();
//     let currentTime = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds() + ":" + d.getMilliseconds();
//     console.log(System.getCurrentAvuserInfoCookie() + ' ' + currentTime)
//     auth_axios.defaults.headers.common['avUserInfo'] = System.getCurrentAvuserInfoCookie()
//     RoleAndPermission.loadPermissionBasedOnAuthRole()
// } else {
//     window.avUserInfo = {};
//     let d = new Date();
//     let currentTime = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds() + ":" + d.getMilliseconds();
//     console.log(System.getCurrentAvuserInfoCookie() + ' ' + currentTime)
//     auth_axios.defaults.headers.common['avUserInfo'] = System.getCurrentAvuserInfoCookie();
//     RoleAndPermission.loadPermissionBasedOnAuthRole()
// }

/**
 * function for set avuser info from cookie
 * author: devanshi patel
 */
// if (System.getCurrentAvuserInfoCookie() !== false) {
//console.log("window.location", window.location);
//console.log("getCurrentSiteSpeedboat: ", System.getCurrentSiteSpeedboat());
// let d = new Date();
// let currentTime = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds() + ":" + d.getMilliseconds();
// auth_axios.defaults.headers.common['avUserInfo'] = System.getCurrentAvuserInfoCookie();
//auth_axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'POST, GET, OPTIONS';
//auth_axios.defaults.headers.common['Authorization'] = 'Bearer ' + document.getElementById("randomVal")?.value;

/* if ("my.dev.avnet.com".toLocaleLowerCase().includes(window.location.host)) { // DEV
    auth_axios.defaults.headers.common['Ocp-Apim-Subscription-Key'] = '7862c28511c34499bb097583cc8df5a4';
} else { // SBX & TEST
    auth_axios.defaults.headers.common['Ocp-Apim-Subscription-Key'] = 'a351df08b15f4b61a455346984a69855';
} */
// auth_axios.defaults.headers.common['Authorization'] = Helper.getAuthorizationToken();
// auth_axios.defaults.headers.common['Ocp-Apim-Subscription-Key'] = Helper.getOcpApimSubscriptionKey();

// RoleAndPermission.loadPermissionBasedOnAuthRole()
// console.log(System.getCurrentAvuserInfoCookie(), 'avUSerInfo')
// console.log(RoleAndPermission.loadPermissionBasedOnAuthRole() , 'roles')
// }

// const cookieEvent = new CustomEvent("cookieChanged", {
//     bubbles: true,
//     detail: {
//         cookieValue: document.cookie,
//         checkChange: () => {
//             if (cookieEvent.detail.cookieValue != document.cookie) {
//                 cookieEvent.detail.cookieValue = document.cookie;
//                 return 1;
//             } else {
//                 return 0;
//             }
//         },
//         listenCheckChange: () => {
//             setInterval(function () {
//                 if (cookieEvent.detail.checkChange() == 1) {
//                     cookieEvent.detail.changed = true;
//                     //fire the event
//                     cookieEvent.target.dispatchEvent(cookieEvent);
//                 } else {
//                     cookieEvent.detail.changed = false;
//                 }
//             }, 1000);
//         },
//         changed: false
//     }
// });

// document.addEventListener("DOMContentLoaded", function (e) {
//     e.target.dispatchEvent(cookieEvent);
// });

// document.addEventListener("cookieChanged", function (e) {
//     e.detail.listenCheckChange();
//     if (e.detail.changed === true) {
//         if (Cookies.get('LtpaToken2')) {
//             window.avUserInfo = JSON.parse(Cookies.get(window.avUserInfo_cookie_name));
//             let d = new Date();
//             let currentTime = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds() + ":" + d.getMilliseconds();
//             console.log(System.getCurrentAvuserInfoCookie() + ' ' + currentTime)
//             auth_axios.defaults.headers.common['avUserInfo'] = System.getCurrentAvuserInfoCookie()
//             RoleAndPermission.loadPermissionBasedOnAuthRole()
//         } else {
//             window.avUserInfo = {};
//             let d = new Date();
//             let currentTime = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds() + ":" + d.getMilliseconds();
//             console.log(System.getCurrentAvuserInfoCookie() + ' ' + currentTime)
//             auth_axios.defaults.headers.common['avUserInfo'] = System.getCurrentAvuserInfoCookie();
//             RoleAndPermission.loadPermissionBasedOnAuthRole()
//         }
//     }
// });

// if (typeof cookieStore !== 'undefined') {
//     cookieStore.addEventListener('change', ({ changed }) => {
//         for (const { name, value } of changed) {
//             if (name === window.avUserInfo_cookie_name) {
//                 if (Cookies.get('LtpaToken2')) {
//                     window.avUserInfo = JSON.parse(Cookies.get(window.avUserInfo_cookie_name));
//                     let d = new Date();
//                     let currentTime = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds() + ":" + d.getMilliseconds();
//                     console.log(System.getCurrentAvuserInfoCookie() + ' ' + currentTime)
//                     auth_axios.defaults.headers.common['avUserInfo'] = System.getCurrentAvuserInfoCookie()
//                     // auth_axios.defaults.headers.common['avUserInfo'] = {"account":{"speedBoat":"v"}}
//                     RoleAndPermission.loadPermissionBasedOnAuthRole()
//                 } else {
//                     window.avUserInfo = {};
//                     let d = new Date();
//                     let currentTime = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds() + ":" + d.getMilliseconds();
//                     console.log(System.getCurrentAvuserInfoCookie() + ' ' + currentTime)
//                     auth_axios.defaults.headers.common['avUserInfo'] = System.getCurrentAvuserInfoCookie();
//                     // auth_axios.defaults.headers.common['avUserInfo'] = {"account":{"speedBoat":"v"}}
//                     RoleAndPermission.loadPermissionBasedOnAuthRole()
//                 }
//             }
//         }
//     });
// }

export default auth_axios